import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api-client";
import { useAuth } from "@/hooks/useAuth";

export function useProfile() {
    const { user } = useAuth();
    return useQuery({
        queryKey: ["profile", user?.id],
        queryFn: async () => {
            return api.getProfile();
        },
        enabled: !!user,
    });
}
